import LBox from "@components/LBox";
import Loading from "@components/LSuspense/Loading";

const LoadingWrapper = () => {
  return (
    <LBox flex={1} justifyContent="center" alignItems="center">
      <Loading
        loading={{
          fadeIn: {
            duration: 350,
          },
        }}
        extendedLoading={{
          delay: 350,
          fadeIn: {
            duration: 350,
          },
        }}
      />
    </LBox>
  );
};
export default LoadingWrapper;
